import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { selectSigninStatus, selectSubscriptionData } from "../../store/auth/auth.selectors";
import { updateEmployee } from "../../store/auth/auth.actions";
import MqttService from "../../services/mqtt/mqtt.service";
import "./verticals.css";
import { Backdrop, CircularProgress } from "@mui/material";
import { NotificationManager } from "react-notifications";
import UserService from "../../services/user/user.service";

class Verticals extends Component {
    constructor(props) {
        super(props);
        this.state = {
            verticals: this.props.subscriptionData.subscription
                ? this.props.subscriptionData.subscription.verticals
                : [],
            isLoading: false,
        };
    }

    componentDidMount() {
        if (
            this.props.subscriptionData.subscription === null ||
            this.props.subscriptionData.subscriptions === null ||
            this.props.subscriptionData.subscription.verticals === null ||
            this.props.subscriptionData.subscription.verticals === []
        ) {
            this.props.history.replace("/");
        }
    }

    componentDidUpdate() {
        if (this.props.subscriptionData.employee !== null) {
            this.props.history.replace("/home");
        }
        if (this.state.subscription !== this.props.subscriptionData.subscription) {
            this.setState({
                subscription: this.props.subscriptionData.subscription,
                verticals: this.props.subscriptionData.subscription
                    ? this.props.subscriptionData.subscription.verticals
                    : [],
            });
        }
    }

    render() {
        return (
            <div className="container">
                <Backdrop
                    sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={this.state.isLoading}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <div className="verticalsMain" style={{ margin: "50px 0px 30px" }}>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            flexWrap: "wrap",
                            //  margin: "0 50px",
                            alignItems: "center",
                            gap: "25px",
                        }}
                        className="verticalMainWrapper"
                    >
                        {this.state.verticals.map((ver, index) => {
                            return (
                                <div
                                    key={index}
                                    className="verticalContainer"
                                    style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
                                >
                                    <img
                                        style={{ width: "150px" }}
                                        src={`https://myciright.com/Ciright/ajaxCall-photo.htm?flag=verticalIcon&compress=0&id=${ver.verticalId}`}
                                        alt="Vertical"
                                    />
                                    <p style={{ margin: "10px" }}>{ver.verticalName}</p>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            justifyContent: "center",
                                            width: "100%",
                                        }}
                                    >
                                        {ver.employees.map((emp, index) => {
                                            return (
                                                <img
                                                    style={{ width: "30px", cursor: "pointer" }}
                                                    src={emp.sphereImage}
                                                    alt="Employee"
                                                    key={index}
                                                    onClick={async (event) => {
                                                        event.preventDefault();
                                                        try {
                                                            this.setState({ isLoading: true });
                                                            const res = await UserService.validateCode(
                                                                this.props.signinStatus.code
                                                            );
                                                            if (res.error != null) {
                                                                this.setState({ isLoading: false });
                                                                if (res.error.response !== undefined) {
                                                                    if (res.error.response.data !== undefined) {
                                                                        if (
                                                                            res.error.response.data instanceof String ||
                                                                            typeof res.error.response.data === "string"
                                                                        ) {
                                                                            NotificationManager.error(
                                                                                "",
                                                                                res.error.response.data,
                                                                                3000
                                                                            );
                                                                        } else if (
                                                                            res.error.response.data.message !==
                                                                                undefined &&
                                                                            (res.error.response.data.message instanceof
                                                                                String ||
                                                                                typeof res.error.response.data
                                                                                    .message === "string")
                                                                        ) {
                                                                            NotificationManager.error(
                                                                                "",
                                                                                res.error.response.data.message,
                                                                                3000
                                                                            );
                                                                        } else {
                                                                            NotificationManager.error(
                                                                                "",
                                                                                "Code Validation Failed.",
                                                                                3000
                                                                            );
                                                                        }
                                                                    }
                                                                }
                                                            } else {
                                                                if (res["status"]) {
                                                                    const data = res["data"];
                                                                    this.props.updateEmployee({ employee: emp });
                                                                    MqttService.publish(
                                                                        JSON.stringify({
                                                                            type: "Signin",
                                                                            token: emp.employeeToken,
                                                                        })
                                                                    );
                                                                    this.setState({ isLoading: false });
                                                                    this.props.history.replace("/home");
                                                                } else {
                                                                    NotificationManager.error(
                                                                        "",
                                                                        "Error while Validating Code.",
                                                                        3000
                                                                    );
                                                                    this.setState({ isLoading: false });
                                                                }
                                                            }
                                                        } catch (err) {
                                                            NotificationManager.error("", err, 3000);
                                                            this.setState({ isLoading: false });
                                                        }
                                                    }}
                                                />
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        signinStatus: selectSigninStatus(state),
        subscriptionData: selectSubscriptionData(state),
    };
};

const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators(
        {
            updateEmployee,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Verticals);
